
































import Vue from 'vue';
import { PrestazioneLogStatoViewModel } from '../../types';
import * as prestazioneApi from '../../services/prestazione-api';

export default Vue.extend({
    props: {
        value: { default: false },
        title: { required: true },
        id: { required: true, type: Number },
        version: { required: true, type: Number },
        statoPrestazioneId: { required: true, type: Number }
    },
    components: {},
    data(): PrestazioneLogStatoViewModel {
        return {
            isOpen: false,
            note: ''
        };
    },
    methods: {
        close() {
            this.isOpen = false;
            this.$emit('close');
        },
        save(e: any) {
            this.$emit('save', e);
            this.close();
        },
        async updateStatus() {
            await prestazioneApi.updateStatus({
                id: this.id,
                version: this.version,
                statoPrestazioneId: this.statoPrestazioneId,
                note: this.note
            });
            this.$emit('save');
        }
    },
    watch: {
        value: {
            handler: function(val) {
                this.isOpen = val;
                this.note = '';
            }
        }
    }
});
